import { render, staticRenderFns } from "./exchange-rate.pug?vue&type=template&id=2dd61a08&scoped=true&lang=pug&external"
import script from "./exchange-rate.js?vue&type=script&lang=js&external"
export * from "./exchange-rate.js?vue&type=script&lang=js&external"
import style0 from "./exchange-rate.scss?vue&type=style&index=0&id=2dd61a08&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd61a08",
  null
  
)

export default component.exports